import { render, staticRenderFns } from "./exhibitor-list-mixin.vue?vue&type=template&id=5d32bed4&scoped=true"
import script from "./exhibitor-list-mixin.vue?vue&type=script&lang=js"
export * from "./exhibitor-list-mixin.vue?vue&type=script&lang=js"
import style0 from "./exhibitor-list-mixin.vue?vue&type=style&index=0&id=5d32bed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d32bed4",
  null
  
)

export default component.exports